import { gettext } from '@eventbrite/i18n';
import React from 'react';
import { LISTING_HEAP_IDS } from '../../../../constants';
import { useScrollDispatch } from '../../../../contexts/ScrollContext';
import { FeatureFlags } from '../../../../types';
import { useTrackComponent } from '../../../hooks/useTrackComponent';
import type { OrganiserListingPageProps } from '../OrganiserListingPage/OrganiserListingPage';
import { LSClickableAvatarWithBadge } from './ListingsAvatarWithBadge';
import './OrganizerTrustSignalInfo.scss';

interface OrganizerTrustSignalProps {
    featureFlags?: FeatureFlags;
    showBadge?: boolean;
    isMobile?: boolean;
}

export type TOrganizerTrustSignalInfoProps = OrganizerTrustSignalProps &
    OrganiserListingPageProps;

export const OrganizerTrustSignalInfo = ({
    organizerName,
    organizerId,
    organizerAvatar,
    featureFlags,
    showBadge,
    isMobile,
}: TOrganizerTrustSignalInfoProps) => {
    const dispatch = useScrollDispatch();
    const ref = React.useRef<HTMLDivElement>(null);

    useTrackComponent({
        ref: ref,
        heap: {
            eventName: LISTING_HEAP_IDS.ORGANIZER_TRUST_SIGNAL_VIEW,
            eventBucketLabel: 'Views on the Organizer Trust Signal section',
        },
    });

    return (
        <section
            className="organizer-info"
            aria-label={gettext('Organizer profile').toString()}
            ref={ref}
            data-testid="top-organizer-component"
        >
            <div
                className="organizer-info__profile"
                data-testid="top-organizer-component-profile"
            >
                <LSClickableAvatarWithBadge
                    organizerId={organizerId}
                    organizerAvatar={organizerAvatar}
                    featureFlags={featureFlags}
                    showBadge={showBadge}
                    isMobile={isMobile}
                />
                {organizerName && (
                    <span className="organizer-info__name-by">
                        {gettext('By')}{' '}
                        <strong
                            className="organizer-info__name-link"
                            onClick={() => {
                                dispatch({
                                    action: 'scroll',
                                    target: 'organizerPanel',
                                });
                            }}
                            style={{ cursor: 'pointer' }}
                            data-testid="top-organizer-component-name"
                        >
                            {organizerName}
                        </strong>
                    </span>
                )}
            </div>
        </section>
    );
};
